import { createSlice } from '@reduxjs/toolkit';
import { getLoggedInUser, verifyOTPAction } from './actions';
import { constants } from 'src/constants';
import { clearStorage, retrieveData, storeData } from 'src/helper/storageHelper';

const initialState = {
  user: null,
  token: retrieveData(constants.authToken),
  language: retrieveData(constants.languageKey) || constants.defaultLanguage,
  status: {
    user: { loading: true, errorMessage: '', successMessage: '' },
    join: { loading: false, errorMessage: '', successMessage: '' },
    signIn: { loading: false, errorMessage: '', successMessage: '' },
  },
  notifications: [],
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState,
    signOut: (state) => {
      state.user = null;
      clearStorage();
      // clearStorage() wipes everything, but the language is a UI preference rather
      // than session data and should survive logging out.
      storeData(constants.languageKey, state.language);
      state.token = '';
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
      storeData(constants.languageKey, action.payload);
    },
    addNotification: (state, action) => {
      console.log('Slice Notification', action.payload);
      state.notifications = [action.payload, ...state.notifications];
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // getLoggedInUser
      .addCase(getLoggedInUser.pending, (state) => {
        state.status.user.loading = true;
      })
      .addCase(getLoggedInUser.fulfilled, (state, action) => {
        state.status.user.loading = false;
        state.user = action.payload.data;
        // A user record without a language must not blank out the current one —
        // that ends up calling i18n.changeLanguage(undefined).
        if (action.payload.data.language) {
          state.language = action.payload.data.language;
          storeData(constants.languageKey, action.payload.data.language);
        }
      })
      .addCase(getLoggedInUser.rejected, (state, action) => {
        state.status.user.loading = false;
        state.status.user.errorMessage = action.error.message;
      })
      // postOTPVerification
      .addCase(verifyOTPAction.pending, (state) => {
        state.status.signIn.loading = true;
      })
      .addCase(verifyOTPAction.fulfilled, (state, action) => {
        state.status.signIn.loading = false;
        if (action.payload.data.token) {
          state.token = action.payload.data.token;
          storeData(constants.authToken, action.payload.data.token);
        }
        state.status.signIn.successMessage = action.payload.message;
      })
      .addCase(verifyOTPAction.rejected, (state, action) => {
        state.status.signIn.loading = false;
        state.status.signIn.errorMessage = action.error.message;
      });
  },
});

export const { reset, signOut, changeLanguage, addNotification, setNotifications, setToken } = authSlice.actions;

export default authSlice.reducer;
